/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scheme-config.vue?vue&type=template&id=4f61a986&scoped=true&"
import script from "./scheme-config.vue?vue&type=script&lang=js&"
export * from "./scheme-config.vue?vue&type=script&lang=js&"
import style0 from "./scheme-config.vue?vue&type=style&index=0&id=4f61a986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f61a986",
  null
  
)

export default component.exports